<template>
  <div>
    <HeaderKuesioner />
    <section class="service-wrapper py-5">
      <div class="container">
        <div class="bg-line"></div>
        <div class="row mt-5">
          <div class="col-12 border-bottom px-4 py-2">
            <div class="row d-flex justify-content-center">
              <div class="col-md-12">
                <h2 class="h2 text-left col-12 mb-3 mt-3 ml-4" style="color: #010D4A;">
                  Cari Alumni
                </h2>
                <form @submit.prevent="handleVerifikasi" class="px-5 py-5">
                  <div v-if="message" class="alert alert-danger rounded mb-5" role="alert">
                    {{ message }}
                  </div>

                  <div class="row">
                    <div class="col-12 mb-4">
                      <h4 class="mb-2">Fakultas</h4>
                      <select name="faculty" @change="getPrograms" class="form-select form-control" v-model="selected"
                        v-validate="'required'" placeholder="Fakultas">
                        <option value="" disabled>---- Pilih Program Fakultas ----</option>
                        <option v-for="faculty in faculties" :key="faculty.id_fakultas" :value="faculty.id_fakultas">
                          {{ faculty.nm_fakultas }}
                        </option>
                      </select>
                      <div v-if="errors.has('faculty')" class="alert alert-danger rounded mt-3" role="alert">
                        Fakultas wajib diisi!
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 mb-4">
                      <h4 class="mb-2">Program Studi</h4>
                      <select name="study_program" @change="getAlumni" class="form-select form-control"
                        v-model="lulusan.id_program_studi" v-validate="'required'">
                        <option value="" disabled>---- Pilih Program Studi ----</option>
                        <option v-for="study_program in study_programs" :key="study_program.id_program_studi"
                          :value="study_program.id_program_studi">
                          {{ study_program.jenjang }} -
                          {{ study_program.nm_program_studi }}
                        </option>
                      </select>
                    <div v-if="errors.has('study_program')" class="alert alert-danger rounded mt-3" role="alert">
                        Program Studi wajib diisi!
                      </div>
                </div>
              </div>
                  <div class="row">
                    <div class="col-md-12 mb-4">
                      <h4 class="mb-2">Nama/NIM Alumni yang dinilai</h4>
                      <list-select :list="list_alumni" option-value="id_alumni" class="form-select form-control"
                        option-text="nm_alumni" :selected-item="selected_alumni" v-validate="'required'" id="mySelectId"
                        name="mySelectName" placeholder="Cari Alumni" @select="selectItem">
                      </list-select>
                    </div>
                  </div>
                  <div v-if="errors.has('mySelectName')" class="alert alert-danger rounded mb-5" role="alert">
                    Nama Alumni wajib diisi!
                  </div>

                  <div class="row d-flex justify-content-center text-right mb-5 mt-3">
                    <div class="col-lg-12 col-12">
                      <div v-show="loading">
                        <Loading />
                      </div>
                      <button class="button-secondary custom_2">
                        Berikutnya
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HeaderKuesioner from "@/components/hero/HeaderKuesioner.vue";
import Loading from "@/components/Loading.vue";
import Alumni from "@/models/alumni";
import SurveyService from "@/services/survey.service";
import DataService from "@/services/data.service";
import { ListSelect  } from 'vue-search-select'

export default {
  name: "Verifikasi",
  components: {
    HeaderKuesioner,
    Loading,
    ListSelect
  },
  data() {
    return {
      alumni: new Alumni(""),
      loading: false,
      message: "",
      survey_id: this.$route.params.id,
      selected: "",
      selected_alumni: {
        id_alumni: '',
        nm_alumni: ''
      },
      faculties: {},
      study_programs: {},
      list_alumni: [{}],
      lulusan: {
        nama_alumni: "",
        id_program_studi: ""
      },
    };
  },
  computed: {
    currentAlumni() {
      return this.$store.state.survey.alumni.data;
    }
  },
  created() {
    if (this.currentAlumni) {
      // this.$router.push("/Q1");
      this.$router.push({
        name: "question2"
        // params: {
        //   id: this.$route.params.id
        // }
      });
    }
  },
  mounted() {
    this.getSurvey();
    this.getFakultas();
  },
  methods: {
    resetItem() {
      this.selected_alumni = {}
    },
    selectItem (selected_alumni) {
      this.selected_alumni = selected_alumni
    },
    getFakultas(){
      DataService.getFaculties()
        .then(res => {
          this.faculties = res.data.faculties;
        })
        .catch(error => console.error(error));
    },
    getPrograms() {
      DataService.getProgramsChoise(this.selected)
        .then(res => {
          this.study_programs = res.data.studyPrograms;
        })
        .catch(error => console.error(error));
    },
    getAlumni() {
      DataService.getAlumniFilter(this.lulusan.id_program_studi)
        .then(res => {
          this.list_alumni = res.data.alumni;
        })
        .catch(error => console.error(error));
    },
    getSurvey() {
      SurveyService.showSurvey(this.survey_id)
        .then(res => {
          this.survey = res.data.survey;
          this.$store.dispatch("survey/dataSurvey", this.survey);
        })
        .catch(error => console.error(error));
    },
    handleVerifikasi() {
      this.$router.push({
        name: "survey-dudi",
        params: {
          id_survey: this.survey_id,
          id_alumni: this.selected_alumni.id_alumni
        }
      });
    }
  }
};
</script>

<style scoped>
.container {
  margin: 20px auto;
  padding: 0;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
  font-family: "Glegoo", sans-serif;
  font-size: 0.8rem;
  line-height: normal;
}

.bg-line {
    background-color: #003E29;
    height: 10px;
    margin-bottom: 20px
}

.forms-inputs {
  position: relative;
}

.forms-inputs span {
  position: absolute;
  top: -18px;
  left: 30px;
  background-color: #fff;
  padding: 5px 10px;
  font-size: 15px;
}

.forms-inputs input {
  height: 50px;
  border: 2px solid #eee;
}

.forms-inputs input:focus {
  box-shadow: none;
  outline: none;
  border: 2px solid #010d4a;
}

.btn {
  height: 50px;
}

.success-data {
  display: flex;
  flex-direction: column;
}

.bxs-badge-check {
  font-size: 90px;
}

@media only screen and (max-width: 480px) {
  .forms-inputs input {
    height: 70px;
    font-size: 0.8rem;
  }

  .forms-inputs select {
    height: 70px;
    font-size: 0.8rem;
  }

  .forms-inputs span {
    font-size: 0.9rem;
  }
}
</style>
